export function getError(fieldName) {
    return this.errors.first(fieldName)
}

export function getErrorFromErrors(errors, fieldName) {
    return errors.first(fieldName)
}
